<template>
  <div class="home">
    <Hero/>
    <SellingPoints/>
      <Screenshots/>
  </div>
</template>

<script>
import Hero from "@/components/Home/Hero.vue";
    import SellingPoints from "@/components/Home/SellingPoints.vue";
    import Screenshots from "@/components/Home/Screenshots.vue";

export default {
  name: "Home",
  components: {
      Hero,
      SellingPoints,
      Screenshots
  }
};
</script>
